import { userIsReadOnly, UserSessionInfo } from "../../auth/AuthService";
import copyrightsIcon from "../icons/Copyrights.svg";
import costsIcon from "../icons/Costs.svg";
import dashboardIcon from "../icons/Dashboard.svg";
import designsIcon from "../icons/Designs.svg";
import priceCalculator from "../icons/Price calculator.svg";
import renewalsIcon from "../icons/Renewals.svg";
import trademarksIcon from "../icons/Trademarks.svg";
import watchesIcon from "../icons/Watches.svg";
import { orgHasCases, userHasCostAccess } from "../organizations/OrganizationService";
import { MenuAccess } from "../users/User.types";
import { userHasOrganizationAccess } from "../users/UserService";
import useNavLinkListStyles from "./NavLinkList.styles";
import NavLinkListItem from "./NavLinkListItem";

export type NavLinkListProps = {
    isMinimized: boolean;
    userSession: UserSessionInfo;
    location: string;
};

/**
 * Check if user has access to a specific menu item
 * Empty array = all access
 * Non-empty array = restricted to specified menu items
 */
const userHasMenuAccess = (user: UserSessionInfo["verifiedUser"], menuItem: MenuAccess): boolean => {
    if (!user?.menuAccess) return true; // No restrictions defined
    if (user.menuAccess.length === 0) return true; // Empty array = all access
    return user.menuAccess.includes(menuItem);
};

function NavLinkMainList(props: NavLinkListProps) {
    const classes = useNavLinkListStyles(props);
    return userHasOrganizationAccess(props.userSession.verifiedUser) ? (
        <ul className={classes.navList}>
            {orgHasCases(props.userSession.selectedOrg) && (
                <NavLinkListItem
                    title="Dashboard"
                    linkTo="/dashboard"
                    icon={dashboardIcon}
                    isMinimized={props.isMinimized}
                    isActive={() => props.location === "/" || props.location === "/dashboard"}
                />
            )}
            {props.userSession.selectedOrg?.hasTrademarks && userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.Trademarks) && (
                <NavLinkListItem title="Trademarks" linkTo="/trademarks" icon={trademarksIcon} isMinimized={props.isMinimized} />
            )}
            {props.userSession.selectedOrg?.hasDesigns && userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.Designs) && (
                <NavLinkListItem title="Designs" linkTo="/designs" icon={designsIcon} isMinimized={props.isMinimized} />
            )}
            {props.userSession.selectedOrg?.hasCopyrights && userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.Copyrights) && (
                <NavLinkListItem title="Copyrights" linkTo="/copyrights" icon={copyrightsIcon} isMinimized={props.isMinimized} />
            )}
            {props.userSession.selectedOrg?.hasWatches && userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.Watches) && (
                <NavLinkListItem title="Watches" linkTo="/watches" icon={watchesIcon} isMinimized={props.isMinimized} />
            )}
            {orgHasCases(props.userSession.selectedOrg) && userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.Renewals) && (
                <NavLinkListItem title="Renewals" linkTo="/renewals" icon={renewalsIcon} isMinimized={props.isMinimized} />
            )}
            {(props.userSession.selectedOrg?.hasTrademarkDisputes || props.userSession.selectedOrg?.hasDesignDisputes) &&
                !userIsReadOnly(props.userSession.verifiedUser) &&
                userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.Disputes) && (
                    <NavLinkListItem title="Disputes" linkTo="/disputes" icon={trademarksIcon} isMinimized={props.isMinimized} />
                )}
            {orgHasCases(props.userSession.selectedOrg) &&
                !userIsReadOnly(props.userSession.verifiedUser) &&
                userHasCostAccess(props.userSession.selectedOrg) &&
                userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.Costs) && (
                    <NavLinkListItem title="Costs" linkTo="/costs" icon={costsIcon} isMinimized={props.isMinimized} />
                )}
            {!userIsReadOnly(props.userSession.verifiedUser) &&
                props.userSession.verifiedUser?.userRoles.some((x) => x.name === "Employee") &&
                userHasMenuAccess(props.userSession.verifiedUser, MenuAccess.PriceCalculator) && (
                    <NavLinkListItem title="Price calculator" linkTo="/price-calculator" icon={priceCalculator} isMinimized={props.isMinimized} />
                )}
        </ul>
    ) : (
        <></>
    );
}

export default NavLinkMainList;
